export default "__VITE_ASSET__b7b51e36__"